module.exports = __webpack_public_path__ + "media/alarm.81a82366.mp3";